<template>
  <ModalDialog
    ref="dialog"
    title="Onboard Account"
    icon="fa-user"
    :submitting="submitting"
    submitTitle="Create"
    @closed="onClosed"
    @submitted="onSubmitted">

    <FormGroup v-bind:form="form" :labelColumnSize="2">
      <ContentTitle>Owner User</ContentTitle>
      <FormRow label="Name"><FormInputText v-model="account.userName" field="userName" placeholder="User Name" /></FormRow>
      <FormRow label="Email"><FormInputText v-model="account.email" field="email" placeholder="Email" /></FormRow>
      <FormRow label="Password"><FormInputText type="password" v-model="account.password" field="password" placeholder="Password" /></FormRow>
      <FormRow label="Confirm Password"><FormInputText type="password" v-model="account.confirmPassword" field="confirmPassword" placeholder="Confirm Password" /></FormRow>

      <ContentTitle>Account</ContentTitle>
      <FormRow label="Company Name"><FormInputText v-model="account.companyName" field="companyName" placeholder="Company Name" /></FormRow>
      
    </FormGroup>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'

import form from '@/mixins/form'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'OnboardAccountDialog',
  mixins: [
    modalDialog,
    form
  ],
  components: {
    ModalDialog
  },
  props: {
  },
  data() {
    return {
      account: { },
      form: {},
      submitting: false
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    show(user) {
      // Reset form
      this.account = { }
      this.form = {}
      this.submitting = false

      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      this.$apiService.developerService.developerOnboardNewAccount(this.account)
        .then(() => {
          this.submitting = false
          this.modalClosed(true)
          this.hide()
        })
        .catch(err => {
          this.submitting = false
          this.$data.form = this.processFormResponse(err)
        })
    },
  }
}
</script>